import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '1本からでも注文できますか？',
      answer: 'はい、1本からでも対応可能です。試作品や少量生産にも柔軟に対応いたします。岡山市近隣の設計担当者様からの小ロット依頼も多数お受けしております。お気軽にご相談ください。',
    },
    {
      question: '納期はどのくらいかかりますか？',
      answer: '製品の仕様や数量によって異なりますが、通常は1週間〜2週間程度です。お急ぎの場合は短納期対応も可能ですので、まずはご相談ください。岡山市内であれば直接お届けすることも可能です。',
    },
    {
      question: 'どのような材質に対応していますか？',
      answer: 'チタン、ステンレス、インコネル、真鍮、アルミニウムなど、様々な材質に対応しています。特に難削材の加工経験が豊富で、他社では対応が難しい材質でもお任せください。',
    },
    {
      question: '図面がなくても相談できますか？',
      answer: 'はい、図面がない場合でもご相談ください。現物やスケッチからでも対応可能です。創業50年の経験を活かし、お客様のニーズに合わせた最適な提案をさせていただきます。',
    },
    {
      question: '見積もりは無料ですか？',
      answer: 'はい、お見積もりは無料です。図面やご要望をお送りいただければ、迅速にお見積もりをご提示いたします。岡山市の製造業の皆様のお役に立てるよう、丁寧に対応させていただきます。',
    },
    {
      question: '品質保証はありますか？',
      answer: 'はい、すべての製品について厳格な品質管理を行っております。0.01mm単位の精度を保証し、検査成績書の発行も可能です。万が一不具合があった場合は、責任を持って対応いたします。',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-navy text-center mb-10 sm:mb-12 lg:mb-16">
          よくあるご質問
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-navy rounded-lg overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 sm:p-6 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <div className="flex items-center flex-1">
                  <div className="w-8 h-8 flex items-center justify-center bg-navy rounded-full flex-shrink-0">
                    <span className="text-white font-bold text-sm sm:text-base">Q</span>
                  </div>
                  <h3 className="ml-3 sm:ml-4 text-sm sm:text-base lg:text-lg font-bold text-navy pr-4">
                    {faq.question}
                  </h3>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-navy transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="bg-gray-50 p-4 sm:p-6">
                  <div className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-navy/10 rounded-full flex-shrink-0">
                      <span className="text-navy font-bold text-sm sm:text-base">A</span>
                    </div>
                    <p className="ml-3 sm:ml-4 text-sm sm:text-base text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;